import admin from "firebase-admin";
import { randomUUID } from "node:crypto";
const app = () => admin.initializeApp(
  {
    credential: admin.credential.cert(serviceAccount)
  },
  randomUUID()
);
const db = () => admin.firestore(app());
const UserCollection = () => db().collection("users");
const LicenseCollection = () => db().collection("licenses");
const InstallerCollection = () => db().collection("installers");
const SessionCollection = () => db().collection("sessions");
const getUsersByEmail = (email) => {
  return UserCollection().where("email", "==", email).get();
};
export {
  InstallerCollection as I,
  LicenseCollection as L,
  SessionCollection as S,
  UserCollection as U,
  getUsersByEmail as g
};
